export enum TabInfo {
  PersonalInfo = 'personalinfo',
  Personalization = 'peronalization',
  DataAndSecurity = 'dataandsecurity',
  Agreements = 'agreements',
}
